import script from "./teacher.vue?vue&type=script&setup=true&lang=js"
export * from "./teacher.vue?vue&type=script&setup=true&lang=js"

import "./teacher.vue?vue&type=style&index=0&id=a06d9ee8&lang=css"
import "./teacher.vue?vue&type=style&index=1&id=a06d9ee8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a06d9ee8"]])

export default __exports__